import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import * as Sentry from '@sentry/angular';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { TokenService } from '@shared/services/token.service';
import { environment } from 'src/environments/environment';

import { AuthService } from './auth.service';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
  private authService: AuthService;
  private expiredToken = false;

  constructor(
    private injector: Injector,
    private tokenService: TokenService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Add the headers if the request is going to the configured server
    const tokenData = this.tokenService.tokenData.getValue();

    // Exclude specific URL request with headers
    // https://stackoverflow.com/questions/55522320/angular-interceptor-exclude-specific-urls
    if (!tokenData || request.headers.get('skip')) {
      return next.handle(request);
    }

    if (request.url.match(environment.token_auth_config.apiBase)) {
      const headers = {
        'Content-Type': 'application/json',
        'access-token': tokenData.accessToken,
        client: tokenData.client,
        expiry: tokenData.expiry,
        'token-type': 'Bearer',
        uid: tokenData.uid
      };

      request = request.clone({
        setHeaders: headers
      });
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        Sentry.captureException(error);
        if (error.status === 401 && !request.url.includes('/auth_sign_in') && !request.url.includes('/flipper_gates')) {
          this.handleExpiredToken();
        }
        return throwError(error);
      })
    );
  }

  handleExpiredToken() {
    // don't logout for others
    if (this.expiredToken) {
      return;
    }

    // have to call authService to clean data
    this.tokenService.setTokenData(null);
    this.authService = this.injector.get(AuthService);
    this.authService.logout(true, false);
    this.expiredToken = true;
  }
}
